var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"back",attrs:{"href":"javascript:;"},on:{"click":_vm.toStorePage}},[_c('em',{staticClass:"back-ico"}),_c('span',{staticClass:"back-text"},[_vm._v(_vm._s(_vm.letter.backPay))])])}
var staticRenderFns = []

export { render, staticRenderFns }